import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

export interface SwitchText {
  orientation: "left" | "right";
  activeValue: string;
  inactiveValue: string
}

@Component({
  selector: 'app-custom-switch',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './custom-switch.component.html',
  styleUrl: './custom-switch.component.scss'
})
export class CustomSwitchComponent {
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Input() text: SwitchText = { 
    orientation: "right", 
    activeValue: this.translateService.instant('common-page.custom-switch.active-label'),
    inactiveValue: this.translateService.instant('common-page.custom-switch.inactive-label')
  };

  @Output() currentStateEmitter: EventEmitter<boolean> = new EventEmitter();

  randomId: string = '';

  constructor(private translateService: TranslateService) {
    this.randomId = this.generateRandomId();
  }

  private generateRandomId(): string {
    return Math.random().toString(36).substring(2);
  }

  toogleCheck() {
    if(!this.disabled) {
      this.checked = !this.checked;
      this.currentStateEmitter.emit(this.checked);
    }
  }
}
